import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: (resolve) => {
        require(["../components/Home"], resolve);
      },
    },
    {
      path: "/news",
      name: "News",
      component: (resolve) => {
        require(["../components/News"], resolve);
      },
    },
    {
      path: "/newsdel/:id",
      name: "Newsdel",
      component: (resolve) => {
        require(["../components/Newsdel"], resolve);
      },
    },
    {
      path: "/product",
      name: "Product",
      component: (resolve) => {
        require(["../components/Product"], resolve);
      },
    },
    {
      path: "/anli",
      name: "Anli",
      component: (resolve) => {
        require(["../components/Anli"], resolve);
      },
    },
    {
      path: "/goto",
      name: "Goto",
      component: (resolve) => {
        require(["../components/Goto"], resolve);
      },
    },
    {
      path: "/building",
      name: "Building",
      component: (resolve) => {
        require(["../components/Building"], resolve);
      },
    },
    {
      path: "/culture",
      name: "Culture",
      component: (resolve) => {
        require(["../components/Culture"], resolve);
      },
    },
    {
      path: "/case",
      name: "Case",
      component: (resolve) => {
        require(["../components/Case"], resolve);
      },
    },
  ],
});

//  判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (to.matched.some((res) => res.meta.requireAuth)) {
    // 判断是否需要登录权限
    if (sessionStorage.getItem("Ticket")) {
      // 判断是否登录
      next();
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js